export function requireAuthIssuer(
  mode: string,
  environment: Record<string, string | boolean | undefined>,
) {
  const issuer = environment.VITE_AUTH_ISSUER;
  if (typeof issuer === "string" && issuer.length > 0) return issuer;
  if (mode === "production") throw new Error("VITE_AUTH_ISSUER is required for production builds");
  return "http://localhost:3000/auth";
}
